module.exports = __webpack_public_path__ + "img/SAFo_SocialMedia_Disinformation.d8c6af6c.svg";